export default {
      id: "reports-usage",
      viewBox: "0 0 28 35.485",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#reports",
      toString: function () {
        return this.url;
      }
    }